import {
  populatedSmsTemplateVariantSchema,
  ratioSchema,
} from "@redotech/redo-marketing-common/campaigns/campaign-definition";
import { TextMessageType } from "@redotech/redo-marketing-core-common/sms";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export type EstimatedSmsCost = z.infer<typeof estimatedSmsCost>;

const estimatedSmsCost = z.object({
  messageType: createEnum(TextMessageType),
  partCount: z.number(),
  carrierFeeForMessageTypePart: z.number(),
  redoCostForMessageTypePart: z.number(),
  abTestWeight: ratioSchema,
});

export const getEstimatedSmsCost = {
  name: "getEstimatedSmsCost" as const,
  input: z.array(populatedSmsTemplateVariantSchema),
  output: z.array(estimatedSmsCost).nullable(),
};
